<template>
  <div class="login">
    <div class="login-area">
      <h1><img src="../../public/static/mp_logo.png" alt="MailPublisherHTMLeditor" width="440" height="184"><br/>
      <span>外部システム連携アカウント管理</span></h1>
      <p class="read">
        HTMLeditor のご利用には、外部システム連携アカウントの登録が必要です。<br>
        作成済みの外部システム連携アカウントのIDとパスワードを入力してください。
      </p>
      <div class="login-inner">
        <form @submit.prevent="setMpApiAccount">
          <fieldset>
            <div>
              <label>
                外部システム連携アカウントID
                <div class="common-input">
                  <input
                    v-model="mpApiId"
                    autocomplete="mpApiId"
                    @keypress.enter.prevent="setMpApiAccount"
                    required>
                </div>
              </label>
            </div>
            <div>
              <label>
                外部システム連携アカウントパスワード
                <div class="common-input">
                  <input
                    type="password"
                    v-model="mpApiPassword"
                    autocomplete="mpApiPassword"
                    @keypress.enter.prevent="setMpApiAccount"
                    required>
                </div>
              </label>
            </div>
          </fieldset>
          <div v-if="existExtAccount" class="button-box">
            <button class="submit normal-btn" type="submit">続ける</button>
            <button class="back normal-btn" @click.prevent="back">戻る</button>
          </div>
          <div v-else class="button-box">
            <button class="submit normal-btn" type="submit">続ける</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      mpApiId: '',
      mpApiPassword: '',
      existExtAccount: false,
    }
  },
  created () {
    const formData = new FormData()
    formData.append('mpDomain', this.$route.params.mpDomain)
    formData.append('siteId', this.$route.params.siteId)
    this.$http({
      type: 'POST',
      url: '/pre_login',
      params: formData,
    }).then(json => {
      if (json && json.status === 200) {
        if (json.data['existExtAccount']) {
          this.existExtAccount = true
        }
      }
    })
  },
  methods: {
    setMpApiAccount () {
      this.$router.push({
        name: 'login',
        params: {
          mpApiId: this.mpApiId,
          mpApiPassword: this.mpApiPassword,
        },
        query: {
          redirect: this.$route.query.redirect
        }
      })
    },
    back () {
      this.$router.push({
        name: 'login',
        query: {
          redirect: this.$route.query.redirect
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.login {
  width: 100vw;
  height: 100vh;
  background: #f8f8f8;
  position: relative;
  .login-area {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: $commonFontColor;
    h1 {
      font-size: 14px;
      position: relative;
      margin-bottom: 20px;
      span {
        display: block;
        line-height: 1;
      }
    }
    .read {
      font-size: 14px;
      margin-bottom: 30px;
    }
    .login-inner {
      text-align: left;
      background: #fff;
      border-radius: 2px;
      box-shadow: 2px 2px 4px rgba(#484848, 0.2);
      width: 440px;
      margin: 0 auto;
      padding: 35px 35px 25px;
      box-sizing: border-box;
      p {
        font-size: 12px;
      }
      form {
        width: 100%;
      }
      label {
        font-size: 12px;
        margin-bottom: 25px;
        width: 370px;
        display: block;
      }
      .common-input {
        padding: 0;
        width: 370px;
        input {
          padding: 8px;
          box-sizing: border-box;
        }
      }
      .button-box {
        display: flex;
        justify-content: center;
        button {
          margin-right: 20px;
          border: solid 1px #484848;
          font-size: 14px;
          border-radius: 5px;
          &:hover {
            opacity: 0.8;
          }
          &.submit {
            color: #fff;
            background: #484848;
          }
          &.back {
            border: solid 1px #c6c6c6;
          }
        }
      }
      .link {
        text-align: center;
      }
    }
  }
}
</style>
